export default __webpack_public_path__ + "static/media/asset-4.956f5771.webp";